<script setup>
import { useAppStore } from '@/stores/App'
import { useDisplay } from 'vuetify'

// mobile breakpoint
const { xs } = useDisplay()

// Vars
const app = useAppStore()
const staticURLImg = useRuntimeConfig().public.staticURLImg
const lightBox = ref(null)
</script>

<template>
    <v-row id="ui" class="mb-16 justify-center slide-from-top">
        <v-col cols="12" class="bg-grey-darken-4 st-bg-pentagon">
            <v-row class="justify-center align-center">
                <v-col cols="8" class="mt-6 rounded">
                    <v-row dense>
                        <template v-for="(ui, n) in app.uiDesigns" :key="ui.alt">
                            <v-col :cols="ui.cols">
                                <v-img
                                    id="cardImg"
                                    :src="staticURLImg + ui.source"
                                    height="100%"
                                    cover
                                    @click.stop="lightBox.open(n)"
                                    class="rounded elevation-1"
                                    :alt="ui.alt"
                                >
                                </v-img>
                            </v-col>
                        </template>
                    </v-row>
                </v-col>
                <v-col cols="12" class="mb-6 mb-md-10 text-center st-subheader">
                    Click an image to open the gallery.
                </v-col>
                <the-lightbox ref="lightBox" :data="app.uiDesigns" />
            </v-row>
        </v-col>
        <v-col cols="12" sm="10" class="mt-3">
            <v-row>
                <v-col cols="12" sm="6" lg="3">
                    <v-card variant="flat" class="st-card st-box-shadow text-center fill-height">
                        <v-card-item>
                            <v-icon color="deep-purple" :size="xs ? 48 : 64"> mdi-check-circle-outline </v-icon>
                        </v-card-item>
                        <v-card-text class="mt-4 text-justify st-card-text">
                            With over 50 audio plugin and app UI designs delivered in diverse styles, we've honed a deep
                            understanding of the technical requirements and specific needs of this domain. This
                            extensive experience positions us as experts in crafting exceptional audio software
                            interfaces.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" lg="3">
                    <v-card variant="flat" class="st-card st-box-shadow text-center fill-height">
                        <v-card-item>
                            <v-icon color="light-blue-darken-2" :size="xs ? 48 : 64"> mdi-artboard </v-icon>
                        </v-card-item>
                        <v-card-text class="mt-4 text-justify st-card-text">
                            Where we truly stand out is in our unwavering dedication to your vision. Unlike others, we
                            don't impose limits on revisions. We believe the creative process thrives on unrestricted
                            exploration and iteration until you, the customer, are absolutely thrilled with the final
                            design.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" lg="3">
                    <v-card variant="flat" class="st-card st-box-shadow text-center fill-height">
                        <v-card-item>
                            <v-icon color="green-darken-3" :size="xs ? 48 : 64"> mdi-message-fast-outline </v-icon>
                        </v-card-item>
                        <v-card-text class="mt-4 text-justify st-card-text">
                            By embracing agile methodologies and sharing progress regularly, we maintain clear
                            communication throughout the project, ensuring we stay aligned with your needs and catch any
                            adjustments that might be needed.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" lg="3">
                    <v-card variant="flat" class="st-card st-box-shadow text-center fill-height">
                        <v-card-item>
                            <v-icon color="cyan-darken-1" :size="xs ? 48 : 64"> mdi-gift-outline </v-icon>
                        </v-card-item>
                        <v-card-text class="mt-4 text-justify st-card-text st-text-shadow">
                            We offer free products as a token of our appreciation for the amazing community that
                            supports us. We're passionate about giving back and are happy to help individual developers,
                            open-source projects, and small teams with their design needs. Feel free to reach out and
                            discuss your project!
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" class="mt-6 text-center">
                    <v-btn
                        text="Let's Discuss"
                        to="/support"
                        size="x-large"
                        color="secondary"
                        aria-label="Contact satYatunes"
                    ></v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped>
.st-bg-pentagon {
    -webkit-clip-path: polygon(0 0, 100% 0, 100% 80%, 50% 100%, 0 80%);
    clip-path: polygon(0 0, 100% 0, 100% 80%, 50% 100%, 0 80%);
}
</style>
